export default (vue) => {
    if (window.vuelidate?.default) {
        vue.use(window.vuelidate.default);
    }
};
